import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47faa496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-panel__row assessment-history" }
const _hoisted_2 = { class: "profile-headline" }
const _hoisted_3 = { class: "profile-headline__title" }
const _hoisted_4 = { class: "assessment-timeline__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow--right-grey" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "assessment-timeline__summary"
}
const _hoisted_7 = {
  key: 0,
  class: "assessment-timeline__tip"
}
const _hoisted_8 = {
  key: 1,
  class: "assessment-timeline__tip"
}
const _hoisted_9 = {
  key: 2,
  class: "assessment-timeline__tip"
}
const _hoisted_10 = { class: "assessment-timeline__header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow--right-grey" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "assessment-timeline__summary"
}
const _hoisted_13 = {
  key: 0,
  class: "assessment-timeline__expand-btn"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-caret--green" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_AssessmentFluctuation = _resolveComponent("AssessmentFluctuation")!
  const _component_PxExpand = _resolveComponent("PxExpand")!
  const _component_AssessmentDetails = _resolveComponent("AssessmentDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("profile.assessment.historyPanel.title")), 1),
      (_ctx.allowLevelUpdate)
        ? (_openBlock(), _createBlock(_component_PxButton, {
            key: 0,
            disabled: !_ctx.$features.isEnabled('updateLevel'),
            class: "profile-headline__updateBtn",
            size: "small",
            onClick: _ctx.onClickUpdateLevel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("profile.assessment.update")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'assessment-timeline--initial': _ctx.hasOneAssessment }, "assessment-timeline"])
    }, [
      _createVNode(_component_PxExpand, { toggle: false }, {
        visible: _withCtx(() => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleResults, (entry, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: _normalizeClass([{ 'assessment-timeline__entry--current': key === 0 }, "assessment-timeline__entry"])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.assessmentTitle(entry)) + " ", 1),
                  (_ctx.$screen.mdUp)
                    ? (_openBlock(), _createBlock(_component_PxButton, {
                        key: 0,
                        class: "el-button--link el-button--link-dark el-button--small",
                        type: "link",
                        onClick: ($event: any) => (_ctx.onClickOpenAssessmentDetails(key))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("profile.assessment.historyPanel.detailsLink")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_PxButton, {
                        key: 1,
                        class: "el-button--arrow",
                        onClick: ($event: any) => (_ctx.onClickOpenAssessmentDetails(key))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                (_ctx.isAssessmentFluctuationVisible(key, entry))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_AssessmentFluctuation, {
                        "current-assessment": _ctx.currentAssessmentData(entry),
                        "prev-assessment": _ctx.previousAssessmentData(key),
                        align: "left"
                      }, null, 8, ["current-assessment", "prev-assessment"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (_ctx.hasOneAssessment && !_ctx.userIsVisitor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("profile.assessment.historyPanel.tip")), 1))
              : _createCommentVNode("", true),
            (_ctx.hasOneAssessment && _ctx.userIsVisitor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("profile.assessment.historyPanel.tipVisitor", {
                  name: _ctx.company.name,
                })), 1))
              : _createCommentVNode("", true),
            (_ctx.noAssessment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("profile.assessment.historyPanel.tipNoAssesments")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        hidden: _withCtx(() => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiddenResults, (entry, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "assessment-timeline__entry"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.assessmentTitle(entry)) + " ", 1),
                  (_ctx.$screen.mdUp)
                    ? (_openBlock(), _createBlock(_component_PxButton, {
                        key: 0,
                        class: "el-button--link el-button--link-dark el-button--small",
                        type: "link",
                        onClick: ($event: any) => (_ctx.onClickOpenAssessmentDetails(key + 4))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("profile.assessment.historyPanel.detailsLink")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_PxButton, {
                        key: 1,
                        class: "el-button--arrow",
                        onClick: ($event: any) => (_ctx.onClickOpenAssessmentDetails(key + 4))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                (_ctx.isAssessmentFluctuationVisible(key, entry))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_AssessmentFluctuation, {
                        "current-assessment": _ctx.currentAssessmentData(entry),
                        "prev-assessment": _ctx.previousAssessmentData(key),
                        align: "left"
                      }, null, 8, ["current-assessment", "prev-assessment"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        trigger: _withCtx(() => [
          (_ctx.hiddenResults.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t("profile.assessment.historyPanel.expand")) + " (" + _toDisplayString(_ctx.assessments.length) + ") ", 1),
                _hoisted_14
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_AssessmentDetails, {
      "selected-assessment": _ctx.currentAssessment,
      "onUpdate:selectedAssessment": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentAssessment) = $event)),
      visibility: _ctx.isAssessmentDetailsVisible,
      "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAssessmentDetailsVisible) = $event)),
      "assessment-list": _ctx.assessments
    }, null, 8, ["selected-assessment", "visibility", "assessment-list"])
  ]))
}